import React, {Suspense} from "react";
import MainLoader from "./MainLoader"

export default ({children}) => {
    return <Suspense fallback={<MainLoader/>}>
        {children}
    </Suspense>
}